import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { assignedTemplateUuidsByCompanyIdStateJ } from '../../../../../services/state/KPI/KPICompaniesStateJ';
import { IKPIRequestDataModel } from '../../../../../data-models/kpi-requests.data-model';
import { kpiTemplatesMapByUuidStateJ } from '../../../../../services/state/KPI/KPITemplatesStateJ';

export function useCanResendRequest() {
  const assignmentTemplateUuidsByCompanyId = useAtomValue(assignedTemplateUuidsByCompanyIdStateJ);
  const templatesByUuid = useAtomValue(kpiTemplatesMapByUuidStateJ);

  return useCallback(
    (request: IKPIRequestDataModel): boolean => {
      const template = templatesByUuid.get(request.templateUuid);
      return Boolean(
        template &&
        assignmentTemplateUuidsByCompanyId.get(request.companyId)?.has(request.templateUuid) &&
        !template.isDeleted
      );
    },
    [assignmentTemplateUuidsByCompanyId, templatesByUuid]
  );
}

export const DisableResendMessage =
  'The request cannot be resent because the template or template assignment was deleted';
